export const TYPES = "types";
export const CATEGORY = "categories";
export const ASSIGNEES = "assignees";
export const MEMBERS = "members";
export const DUE_DATE = "dueDate";
export const PRIORITIES = "priorities";
export const STATUSES = "statuses";
export const CONSULT_DATE = "consultDate";
